<template>
  <div>
    <grade-update-dialog v-bind:grade="selected" :state="EditGrade" />
    <v-btn class="elevation-0" icon @click="EditGrade = !EditGrade">
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
      </template>
      <v-list>
        <v-list-item @click="onRemove()">
          <v-list-item-title>Xóa</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import GradeUpdateDialog from '@/modules/grade/GradeUpdateDialog.vue'

export default {
  components: {
    GradeUpdateDialog
  },
  props: {
    selected: { type: Object, default: () => [] }
  },
  data() {
    return {
      sending: null,
      EditGrade: false
    }
  },
  computed: {
    ...mapState('grade', ['Grades'])
  },
  methods: {
    ...mapActions('grade', ['removeGrade', 'updateGrade']),
    ...mapActions('class', ['countClassesIndependent']),
    async onRemove() {
      let text = 'Bạn có chắc muốn xóa học phần này?'
      const hasClasses = await this.countClassesIndependent({ grade: this.selected.id })
      if (hasClasses)
        text = 'Việc xóa học phần này sẽ xóa các lớp học liên quan. Bạn có chắc muốn xóa học phần này?'
      this.$dialog.confirm({
        title: 'Xóa học phần',
        text,
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeGrade(this.selected.id)
        }
      })
    },
    onEdit() {
      this.$emit('onEdit', this.selected)
    }
  }
}
</script>
